import React, { useState } from 'react';
import { useLang } from '../../contexts/LangContext';
import BillingPeriodMonthPicker from '../../components/common/BillingPeriodMonthPicker';
import { describeNoticePeriodSummary } from '../../utils/feeBillingTiming';
import { getCurrentBillingPeriodValue } from '../../utils/billingPeriodPicker';
import FeeStatisticsTab from './FeeStatisticsTab';
import FeeDetailsTab from './FeeDetailsTab';
import CreateFeesTab from './CreateFeesTab';

type TabId = 'statistics' | 'details' | 'create';

const TABS: { id: TabId; label: string }[] = [
  { id: 'statistics', label: 'Thống kê phí' },
  { id: 'details', label: 'Chi tiết phí' },
  { id: 'create', label: 'Tạo phí' },
];

const ServiceFeeManagement: React.FC = () => {
  const { t } = useLang();
  const [activeTab, setActiveTab] = useState<TabId>('statistics');
  const [billingPeriod, setBillingPeriod] = useState(getCurrentBillingPeriodValue());

  return (
    <div className="max-w-[1400px] mx-auto p-6">
      <nav className="flex mb-4 text-sm text-gray-500">
        <span>PHÍ DỊCH VỤ</span>
        <span className="mx-2">/</span>
        <span className="text-cyan-600 font-medium">
          {t('SERVICE_FEE_MANAGEMENT') || 'Quản lý phí dịch vụ'}
        </span>
      </nav>

      <h1 className="text-2xl font-bold text-gray-900 mb-4">
        {t('SERVICE_FEE_MANAGEMENT') || 'Quản lý phí dịch vụ'}
      </h1>

      {activeTab !== 'create' && (
        <div className="flex flex-wrap items-center gap-3 mb-6">
          <span className="text-sm font-medium text-gray-700">Kỳ thu phí</span>
          <BillingPeriodMonthPicker value={billingPeriod} onChange={setBillingPeriod} />
          <span className="text-xs text-gray-500 max-w-xl">
            {describeNoticePeriodSummary(billingPeriod)}
            {activeTab === 'details' && (
              <>
                {' '}
                · Nhập công nợ nhận bàn giao: chọn kỳ cần ghi <strong>Nợ đầu kỳ</strong> (vd.{' '}
                <strong>09/2026</strong> cho snapshot legacy cuối 08/2026).
              </>
            )}
          </span>
        </div>
      )}

      <div className="border-b border-gray-200 mb-6">
        <div className="flex gap-1">
          {TABS.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`px-5 py-3 text-sm font-medium border-b-2 transition-colors ${
                activeTab === tab.id
                  ? 'border-emerald-600 text-emerald-700'
                  : 'border-transparent text-gray-600 hover:text-gray-900 hover:border-gray-300'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {activeTab === 'statistics' && <FeeStatisticsTab billingPeriod={billingPeriod} />}
      {activeTab === 'details' && <FeeDetailsTab billingPeriod={billingPeriod} />}
      {activeTab === 'create' && <CreateFeesTab />}
    </div>
  );
};

export default ServiceFeeManagement;
